export const downPaymentOptions = [
  { label: '0%', value: 0 },
  { label: '10%', value: 10 },
  { label: '15%', value: 15 },
  { label: '20%', value: 20 },
  { label: '25%', value: 25 },
  { label: '30%', value: 30 },
];

export const creditTermOptions = [
  { label: '5 лет', value: 5 },
  { label: '10 лет', value: 10 },
  { label: '15 лет', value: 15 },
  { label: '20 лет', value: 20 },
];
